import React from "react";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import HomeSubSection from "../WebSite/HomeSubSection/HomeSubSection";
import "./FinancialService.css";


// FinancialService functional component receives props
export default function FinancialService(props) {
  // Extracting customProp value from the location state of props
  const customPropValue = props.location?.state?.customProp;

  // Define sections with various financial services descriptions
  const ffSection = (
    <HomeSubSection
      className="rowReverseAbout borderedCards borderedCards--mod"
      className3="fieldSupportService5"
      descriptionTitle="Loan"
      description="GBR Care extends a diverse range of financial services to agri-storage providers, empowering them to optimize operations and achieve financial sustainability in the agricultural ecosystem."
    />
  );

  const ffSection1 = (
    <HomeSubSection
      className="rowReverseAbout borderedCards borderedCards--mod"
      className3="fieldSupportService5"
      descriptionTitle="Loan"
      description="GBR Care offers a specialized loan service designed to support agri-retailers, facilitating access to necessary funding. This service aims to enhance financial stability and growth opportunities within the agricultural retail sector."
    />
  );

  const CollectivesSection = (
    <HomeSubSection
      className="rowReverseAbout borderedCards borderedCards--mod"
      className3="fieldSupportService5"
      descriptionTitle="Loan"
      description="GBR Care extends its expertise in financial support by providing a specialized loan service tailored for collectives. Through this service, GBR Care facilitates access to crucial funding for collectives, enabling them to pursue their agricultural ventures with confidence."
    />
  );

  const growerSection = (
    <HomeSubSection
      className="rowReverseAbout borderedCards borderedCards--mod"
      className3="fieldSupportService5"
      descriptionTitle="Loan"
      description="GBR Care facilitates a comprehensive range of financial services, including asset loans for agricultural fields and processing assets. Our loan services are designed to provide essential financial support to Agri-Entrepreneurs, enabling them to acquire the necessary assets for their operations."
    />
  );

  const PMSection = (
    <HomeSubSection
      className="rowReverseAbout borderedCards borderedCards--mod"
      className3="fieldSupportService5"
      descriptionTitle="Loan"
      description="GBR Care offers dedicated loan services to agri-contract manufacturers, providing crucial financial support for machinery acquisition and operational optimization in the agricultural industry."
    />
  );

  const LPSection = (
    <HomeSubSection
      className="rowReverseAbout borderedCards borderedCards--mod"
      className3="fieldSupportService5"
      descriptionTitle="Loan"
      description="GBR Care enables agri-transporters to access tailored loan services, providing essential financial support for optimizing their transportation operations within the agricultural sector."
    />
  );

  return (
    <>
      <HeaderComponent /> {/* Header component rendering */}
      <UpdatesBanner
        className="financialSupportServiceBanner"
        bannerText={["Financial Services"]} // Banner with the title Financial Services
      />
      <div className="subSectionWrapper">
        {/* Conditional rendering based on customPropValue */}
        {/* Render the appropriate financial service section based on the passed customProp */}
        {!customPropValue && growerSection} {/* Default to grower section if no customPropValue */}
        {customPropValue === "farming" && growerSection} {/* Show grower section if customPropValue is "farming" */}
        {customPropValue === "storage" ? ffSection : null} {/* Show storage section if customPropValue is "storage" */}
        {customPropValue === "processing" && PMSection} {/* Show processing section if customPropValue is "processing" */}
        {customPropValue === "selling" ? ffSection1 : null} {/* Show selling section if customPropValue is "selling" */}
        {customPropValue === "transport" ? LPSection : null} {/* Show transport section if customPropValue is "transport" */}
        {customPropValue === "collectives" ? CollectivesSection : null} {/* Show collectives section if customPropValue is "collectives" */}
      </div>
      <FooterComponent /> {/* Footer component rendering */}
    </>
  );
}
